import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Phone, MapPin, Mail } from "lucide-react";

export const Footer = () => (
  <footer className="bg-brand-midnight text-white/80">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
      <div className="md:col-span-2">
        <Logo light />
        <p className="mt-4 max-w-sm text-sm text-white/60 leading-relaxed">
          White-glove packing, unpacking, organization, staging, and interior rearrangement for the
          Pensacola & Emerald Coast. Licensed & bonded in Florida. Local crew, never outsourced.
        </p>
        <div className="mt-5 space-y-2 text-sm">
          <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-brand-gold" /> (850) 555-0142</div>
          <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-brand-gold" /> hello@pack2perfect.com</div>
          <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-brand-gold" /> Serving Escambia & Santa Rosa County</div>
        </div>
      </div>
      <div>
        <h4 className="font-display font-semibold text-white mb-4">Quick Links</h4>
        <ul className="space-y-2 text-sm">
          <li><a href="#services" className="hover:text-brand-gold">Services</a></li>
          <li><a href="#pricing" className="hover:text-brand-gold">Pricing & Blocks</a></li>
          <li><a href="#portfolio" className="hover:text-brand-gold">Portfolio</a></li>
          <li><a href="#realtors" className="hover:text-brand-gold">Realtor Partners</a></li>
          <li><Link to="/admin" className="hover:text-brand-gold">Owner Console</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display font-semibold text-white mb-4">Service Zones</h4>
        <ul className="space-y-2 text-sm text-white/60">
          <li>Pensacola & East Hill</li>
          <li>Gulf Breeze</li>
          <li>Pensacola Beach</li>
          <li>Perdido Key</li>
          <li>Milton & Pace</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
        <span>© {new Date().getFullYear()} Pack 2 Perfection. All rights reserved.</span>
        <span>Licensed & Bonded • Zero-Stress Move Guarantee</span>
      </div>
    </div>
  </footer>
);
